module.exports = __webpack_public_path__ + "img/healthcare-section2.d89bb391.svg";